var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "734c4f682e6f7f2d57ea1ee3d1f15ec735fdf60b"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["launchpad@printdeal"] = {
  id: "734c4f682e6f7f2d57ea1ee3d1f15ec735fdf60b"
};